export function getCategoriesRoutes() {
  return [
    {
      path: "/categories",
      name: "categories",
      component: () => import(/* webpackChunkName: categories-old-backend */ "./components/CategoriesOld.vue"),
    },
  ]
}
